import { openModalAlert } from 'js/services/modals.js';
import template from './modal-leadtags-config.pug';

export default Vue.extend({
  name: 'ModalLeadtagsConfig',
  template: template(),
  props: {
    fieldData: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      data: {
        id: this.fieldData.id,
        name: this.fieldData.name,
        fieldType: this.fieldData.fieldType
      },
      typeOptions: [
        { label: this.t('options.text'), value: 'text' },
        { label: this.t('options.number'), value: 'number' },
        { label: this.t('options.date'), value: 'date' }
      ],
      errors: {}
    };
  },
  computed: {
    disabledSave() {
      return !this.data.name || !this.data.fieldType;
    }
  },
  methods: {
    t(key) {
      return this.$t(`campaigns.show.config.tabs.leadTags.${key}`);
    },
    //Acá se validan los cambios.
    saveChanges() {
      if (this.validate()) {
        this.$emit('submit', this.data);
        this.cancel();
      }
      else{
        openModalAlert(
          this.t('errorTittle'),
          this.t('error'),
          this.t('okButton')
        );
      }
    },
    validate() {
      this.errors = {};
      return Object.keys(this.errors).length === 0;
    },
    cancel() {
      this.$emit('cancel');
    }
  }
});
